/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { OpprettSikkerInnsendingDataTo } from '../models/opprett-sikker-innsending-data-to';
import { SendInnSikkerInnsendingDataTo } from '../models/send-inn-sikker-innsending-data-to';


/**
 * Sikker-innsending-API
 */
@Injectable({
  providedIn: 'root',
})
export class SikkerInnsendingService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createNewSchema
   */
  static readonly CreateNewSchemaPath = '/sikker-innsending/opprett';

  /**
   * Sikker-innsending-tjeneste for arkivering av data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createNewSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  createNewSchema$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<OpprettSikkerInnsendingDataTo>> {

    const rb = new RequestBuilder(this.rootUrl, SikkerInnsendingService.CreateNewSchemaPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OpprettSikkerInnsendingDataTo>;
      })
    );
  }

  /**
   * Sikker-innsending-tjeneste for arkivering av data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createNewSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createNewSchema(params?: {
  },
  context?: HttpContext

): Observable<OpprettSikkerInnsendingDataTo> {

    return this.createNewSchema$Response(params,context).pipe(
      map((r: StrictHttpResponse<OpprettSikkerInnsendingDataTo>) => r.body as OpprettSikkerInnsendingDataTo)
    );
  }

  /**
   * Path part for operation submitSchema
   */
  static readonly SubmitSchemaPath = '/sikker-innsending/sendinn';

  /**
   * Sikker-innsending-tjeneste for arkivering av data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submitSchema()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submitSchema$Response(params?: {
    body?: SendInnSikkerInnsendingDataTo
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SikkerInnsendingService.SubmitSchemaPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Sikker-innsending-tjeneste for arkivering av data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `submitSchema$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  submitSchema(params?: {
    body?: SendInnSikkerInnsendingDataTo
  },
  context?: HttpContext

): Observable<void> {

    return this.submitSchema$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
